import { z } from 'zod';

import { Fields } from '../constants';
import { apiCredentialsFormSchema } from './apiCredentialsFormSchema';
import { databaseCredentialsSecretFormSchema } from './databaseCredentialsSchema';
import { passwordSecretFormSchema } from './passwordSecretFormSchema';
import { paymentCardSecretFormSchema } from './paymentCardSecretFormSchema';
import { secureNoteSecretFormSchema } from './secureNoteSecretFormSchema';
import { sshKeyFormSchema } from './sshKeyFormSchema';

export const secretFormSchema = z.discriminatedUnion(Fields.TYPE, [
    passwordSecretFormSchema,
    paymentCardSecretFormSchema,
    apiCredentialsFormSchema,
    databaseCredentialsSecretFormSchema,
    sshKeyFormSchema,
    secureNoteSecretFormSchema,
]);

export type SecretFormSchemaType = typeof secretFormSchema;

export type SecretFormValues = z.infer<typeof secretFormSchema>;

export type PasswordSecretFormValues = z.infer<typeof passwordSecretFormSchema>;
